document.addEventListener("DOMContentLoaded", () => {
  // Get menu elements
  const mobileMenuButton = document.querySelector(".mobile-menu-button");
  const mobileMenuClose = document.querySelector(".mobile-menu-close");
  const mobileMenu = document.querySelector(".mobile-menu");

  // Debug check
  if (!mobileMenuButton || !mobileMenuClose || !mobileMenu) {
    return;
  }

  // Add click handlers
  mobileMenuButton.addEventListener("click", () => {
    mobileMenu.classList.remove("hidden");
    document.body.style.overflow = "hidden"; // Prevent scrolling
  });

  mobileMenuClose.addEventListener("click", () => {
    mobileMenu.classList.add("hidden");
    document.body.style.overflow = ""; // Restore scrolling
  });

  // Close menu when clicking outside
  mobileMenu.addEventListener("click", (e) => {
    if (e.target === mobileMenu) {
      mobileMenu.classList.add("hidden");
      document.body.style.overflow = "";
    }
  });

  // Close menu when pressing escape
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && !mobileMenu.classList.contains("hidden")) {
      mobileMenu.classList.add("hidden");
      document.body.style.overflow = "";
    }
  });
});
